angular.module('cvsApp').service('updatePatientShippingAddressService',
        ['networkService', 'xdrService', 'configManager', 'updatePatientShippingAddressModel', 'cvsAppData', function(NS, XS, CM, UPSAM, CAD) {

    function updatePatientShippingAddress() {
        this.updatePatientShippingAddress = function(callBackSuccess, address) {
            //get url
            var tokenId = CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var url = CM.getAPIUrlWithOtherInfo('UPDATE_SHIPPING_ADDRESS', tokenId, CAD.getTokenType());
            if (url === "URL_ERROR") {

            } else {
                var plainUrl = CM.getPlainApiUrl(url);
                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                var request = {
                    url: plainUrl,
                    header: {
                        Accept: "application/json"

                    },
                    data: requestBody(address),
                    onSuccess: callBackSuccess
                }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(plainUrl, "", xdrSuccess);

                    function xdrSuccess(data) {
                        UPSAM.setResponse(data);
                        callBackSuccess(UPSAM.getResponse());
                    }
                } else {
                    // console.log("reqqqqqq", request);
                    var promise = NS.post(request);
                    promise.then(function(data, c, d) {

                        UPSAM.setResponse(data.data);
                        callBackSuccess(UPSAM.getResponse());

                    }, function(reason) {
                         callBackSuccess(NS.httpError(reason));
                    });
                }
            }

        }

        var requestBody = function(address) {
            var tokenId = CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            return {
                "updatePatientShippingAddressRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "tokenID": tokenId,
                            "tokenType": tokenType
                        },
                        "securityContext": {
                            "apiKey": apikey
                        }
                    },
                    "details": {
                        "address": address
                    }
                }
            }

        }

    }

    return new updatePatientShippingAddress();
}]);
